import { useProjectUpdateQuery } from '@/hook';
import { Edit, VFlex } from '@/package';
import { VButton } from '@/package';
import type { Project } from '@/type';

import ProjectCreateForm from './ProjectCreateForm';

const ProjectEditForm = ({
  projectDetailData,
  projectDetailDataUpdatedAt,
}: {
  projectDetailData: Project;
  projectDetailDataUpdatedAt: number;
}) => {
  const { mutate: updateProject } = useProjectUpdateQuery();

  return (
    <VFlex justify="center" className="w-full pt-[24px]">
      <ProjectCreateForm
        key={projectDetailDataUpdatedAt}
        defaultValue={projectDetailData}
        renderFooter={methods => {
          const onClick = () => {
            updateProject({
              ...projectDetailData,
              ...methods.getValues(),
              defaultInterval: +methods.getValues().defaultInterval,
              pProjectID: projectDetailData.id,
            });
          };
          const isDirty = methods.formState.isDirty;

          return (
            <VFlex className="w-full" justify="end">
              <VButton
                className="w-[324px]"
                onClick={onClick}
                type="button"
                disabled={!isDirty}
              >
                <Edit />
                Edit project
              </VButton>
            </VFlex>
          );
        }}
      />
    </VFlex>
  );
};

export default ProjectEditForm;
